import React, { Component } from "react";
import { connect } from "react-redux";
import {
  StyledBrandKitLogosGrid,
  StyledBrandkitSectionLabels,
} from "../../_components/styled/settings/stylesSettings";
import FontsDropZone from "../../_components/common/FontsDropZone";
import TextMyFont from "../../_components/details/sidebarPanels/textsPanel/TextMyFont";
import { withTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";

class BrandKitFontsSection extends Component {
  render() {
    const { brandKitInfo, brandKit, workspacePermissionChecks, t, fontsDropzoneClassName } = this.props;
    const { canEditBrandKitFont } = workspacePermissionChecks;
    const { loaded } = brandKit;
    const { fonts } = brandKitInfo;

    let brandFontChildren;

    if (loaded) {
      brandFontChildren =
        fonts &&
        fonts.map((font, index) => {
          return (
            <TextMyFont
              font={font}
              brandKitId={brandKitInfo.id}
              key={index}
              addToArtboard={false}
            />
          );
        });
    }

    return (
      <Box w='100%'>
        <StyledBrandkitSectionLabels>
          <label>{t("brandkit.fonts")}</label>
        </StyledBrandkitSectionLabels>
        {canEditBrandKitFont && (
          <FontsDropZone
            brandKitId={brandKitInfo.id}
            checkForCustomFonts={false}
            buttonWidth={this.props.isMobileView ? 75 : 25}
            className={fontsDropzoneClassName}
          />
        )}
        {fonts && fonts.length > 0 && (
          <StyledBrandKitLogosGrid>{brandFontChildren}</StyledBrandKitLogosGrid>
        )}
      </Box>
    );
  }
}

BrandKitFontsSection.propTypes = {};

const mapStateToProps = (state) => ({
  brandKit: state.brandKit,
  workspacePermissionChecks: state.permissions.workspacePermissionChecks,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation(["planner"])(
  connect(mapStateToProps, mapDispatchToProps)(BrandKitFontsSection)
);
